
import { defineComponent, computed } from '@vue/runtime-core'
import { useRoute } from 'vue-router'
import { gotoClientLogin } from '@/utils/stock'
export default defineComponent({
  props: {
    gutter: Number,
    span: Number,
    courses: Object,
    withoutIntroduce: {
      type: Boolean,
      default: true
    },
    isSubject: {
      type: Boolean,
      default: false
    }
  },
  setup(porps: any, context: any) {
    const route = useRoute()
    const defaultImg = computed(() => {
      return route.query.theme === 'dark' 
        ? require('@/assets/nodata_dark_v.png') 
        : require('@/assets/nodata_light_v.png')
    })
    function jumpToCourse(courseNo: number, lessonNo: number, courseType: number) {
      if (!route.query.token) {
        gotoClientLogin()
        return
      }
      context.emit('jumpToCourse', { courseNo, lessonNo, courseType })
    }
    function gotoSpecialCourse(item: any) {
      context.emit('gotoSpecialCourse', item)
    }

    return {
      defaultImg,
      jumpToCourse,
      gotoSpecialCourse
    }
  }
})
